var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button"},[_c('renderro-button',{staticClass:"change-button",attrs:{"disabled":_vm.spinning || _vm.disabled,"spinning":_vm.spinning}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }